import * as React from "react";
import { CopyKeyButton } from "./CopyKeyButton";
import { NameInput } from "./NameInput";
import { ArchiveButton } from "./ArchiveButton";
import { CreatedAtDisplay } from "./CreatedAtDisplay";
import { UpdateApiKeyFunction } from "../ApiKeyUpdater";
import { ApiKey } from "../../types";

// // // //

export function ApiKeyListItem(props: {
    apiKey: ApiKey;
    loading: boolean;
    index: number;
    onUpdateApiKey: UpdateApiKeyFunction;
}) {
    const { apiKey, loading, onUpdateApiKey } = props;

    return (
        <tr className="select-none transition-colors bg-card hover:bg-slate-50">
            <td className="px-6 py-4 min-w-1/3 w-1/3">
                <div className="flex items-center w-full">
                    <NameInput
                        name={apiKey.name}
                        loading={loading}
                        onChange={(updatedName: string) => {
                            return onUpdateApiKey({
                                ...apiKey,
                                name: updatedName,
                            });
                        }}
                    />
                </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-secondary-foreground">
                <CopyKeyButton apiKey={apiKey} />
            </td>

            <td className="hidden sm:table-cell px-6 py-4 whitespace-nowrap text-secondary-foreground capitalize">
                <CreatedAtDisplay
                    createdAt={apiKey.createdAt}
                    createdAtTimeAgo={apiKey.createdAtTimeAgo}
                />
            </td>

            <td className="hidden sm:table-cell px-6 py-4 whitespace-nowrap text-secondary-foreground">
                {apiKey.createdByUserEmail}
            </td>

            <td className="px-6 py-4 justify-end gap-2 hidden sm:flex">
                <ArchiveButton
                    apiKey={apiKey}
                    loading={loading}
                    onConfirmArchive={() => {
                        onUpdateApiKey({ ...apiKey, archived: true });
                    }}
                />
            </td>
        </tr>
    );
}
